class UserDetailsComponentController {
    constructor(securityService) {
        this._securityService = securityService;
    }

    $onChanges(changesObj) {
        this.curtinId = changesObj.userCurtinId.currentValue ? changesObj.userCurtinId.currentValue: this._securityService.getAutheticatedUserId();
        this.givenName = changesObj.userGivenName.currentValue ? changesObj.userGivenName.currentValue:  this._securityService.getAutheticatedUserName();
        this.title = changesObj.sectionTitle.currentValue ? changesObj.sectionTitle.currentValue : 'Personal Details';
    }
}

UserDetailsComponentController.$inject = ['securityService'];

export default  {
    templateUrl: 'app/components/user-details/user-details.html',
    controller: UserDetailsComponentController,
    bindings: {
        userCurtinId: '@',
        userGivenName: '@',
        sectionTitle: '@'
    }
};


// WEBPACK FOOTER //
// ./app/components/user-details/user-details.component.js